import React from 'react';
import { motion } from 'framer-motion';
import { Check, X, Map, Calendar, Droplets } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-20 px-6 bg-[#8B9D83]/10" data-id="element-54">
      <div className="max-w-5xl mx-auto" data-id="element-55">
        <div className="grid md:grid-cols-2 gap-12 mb-20" data-id="element-56">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white p-8 rounded-2xl shadow-sm" data-id="element-57">
            <h3 className="text-xl font-serif font-semibold text-[#D4A59A] mb-6 flex items-center gap-2" data-id="element-58">
              <X className="w-5 h-5" data-id="element-59" /> What this is NOT
            </h3>
            <ul className="space-y-4" data-id="element-60">
              <li className="flex items-start gap-3 text-[#5A5A5A]" data-id="element-61">
                <span className="w-1.5 h-1.5 rounded-full bg-[#D4A59A] mt-2.5 shrink-0" data-id="element-62" />
                A "replace your whole house" detox
              </li>
              <li className="flex items-start gap-3 text-[#5A5A5A]" data-id="element-63">
                <span className="w-1.5 h-1.5 rounded-full bg-[#D4A59A] mt-2.5 shrink-0" data-id="element-64" />
                A lecture about clean living
              </li>
              <li className="flex items-start gap-3 text-[#5A5A5A]" data-id="element-65">
                <span className="w-1.5 h-1.5 rounded-full bg-[#D4A59A] mt-2.5 shrink-0" data-id="element-66" />
                A list of 47 products to buy
              </li>
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white p-8 rounded-2xl shadow-sm border-2 border-[#8B9D83]/20" data-id="element-67">
            <h3 className="text-xl font-serif font-semibold text-[#8B9D83] mb-6 flex items-center gap-2" data-id="element-68">
              <Check className="w-5 h-5" data-id="element-69" /> What this IS
            </h3>
            <p className="text-lg text-[#2D2D2D] font-medium mb-4" data-id="element-70">
              A 14-day sequence that resets your home in the only order that
              gives you clear feedback.
            </p>
            <p className="text-[#5A5A5A]" data-id="element-71">
              So you stop spending money out of panic. And you stop carrying the
              mental load alone.
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-[#8B9D83] rounded-3xl p-8 md:p-12 text-white relative overflow-hidden" data-id="element-72">
          {/* Background pattern */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -translate-y-1/2 translate-x-1/2 blur-3xl" data-id="element-73" />

          <div className="relative z-10" data-id="element-74">
            <div className="text-center mb-12" data-id="element-75">
              <h2 className="text-3xl md:text-4xl font-serif mb-4" data-id="element-76">
                The Unique Mechanism
              </h2>
              <p className="text-white/80 text-lg max-w-2xl mx-auto" data-id="element-77">
                Stop guessing. Start following a system designed for clarity.
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-8" data-id="element-78">
              <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/10" data-id="element-79">
                <div className="bg-white/20 w-12 h-12 rounded-lg flex items-center justify-center mb-4" data-id="element-80">
                  <Map className="w-6 h-6 text-white" data-id="element-81" />
                </div>
                <h4 className="text-xl font-semibold mb-2" data-id="element-82">
                  Trigger Touchpoints Map
                </h4>
                <p className="text-white/80 text-sm leading-relaxed" data-id="element-83">
                  Identify the exact places fragrance and residue keep touching
                  your child (including "sneaky extras" like car seats).
                </p>
              </div>

              <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/10" data-id="element-84">
                <div className="bg-white/20 w-12 h-12 rounded-lg flex items-center justify-center mb-4" data-id="element-85">
                  <Calendar className="w-6 h-6 text-white" data-id="element-86" />
                </div>
                <h4 className="text-xl font-semibold mb-2" data-id="element-87">
                  14-Day Swap Sequence
                </h4>
                <p className="text-white/80 text-sm leading-relaxed" data-id="element-88">
                  Reset in order—Laundry → Bath/Body → Bedroom—so you can tell
                  what's helping without changing everything at once.
                </p>
              </div>

              <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/10" data-id="element-89">
                <div className="bg-white/20 w-12 h-12 rounded-lg flex items-center justify-center mb-4" data-id="element-90">
                  <Droplets className="w-6 h-6 text-white" data-id="element-91" />
                </div>
                <h4 className="text-xl font-semibold mb-2" data-id="element-92">Residue Rules</h4>
                <p className="text-white/80 text-sm leading-relaxed" data-id="element-93">
                  Learn the simple dosing + extra rinse approach that prevents
                  detergent buildup from quietly re-irritating skin.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}